import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import Icon from "../../Styled/Icon";
import { jsx as _jsx } from "react/jsx-runtime";
const MoreOrLess = createReactClass({
  getInitialState: function () {
    return {
      isOpen: this.props.initialopen
    };
  },
  displayName: "MoreOrLess",
  propTypes: {
    initialopen: PropTypes.bool,
    myclass: PropTypes.string
  },
  toggleIcon: function () {
    this.setState({
      isOpen: !this.state.isOpen
    });
  },
  render: function () {
    return /*#__PURE__*/_jsx("button", {
      type: "button",
      onClick: this.toggleIcon,
      className: this.props.myclass,
      children: /*#__PURE__*/_jsx(Icon, {
        glyph: this.state.isOpen ? Icon.GLYPHS.showLess : Icon.GLYPHS.showMore
      })
    });
  }
});
export default MoreOrLess;